module.exports = __webpack_public_path__ + "static/img/sjtj-title.2468590.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xiayan/assets/img/sjtj-title.png
// module id = JlJI
// module chunks = 1